import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
const sortIconStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '2px',
};
function ReactTableHeader({ headerGroups, onClick }) {
    return (_jsx("thead", { children: headerGroups.map((headerGroup) => {
            const { key: headerGroupKey, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
            return (_jsx("tr", { ...restHeaderGroupProps, children: headerGroup.headers.map((column) => (_jsx(HeaderCell, { column: column, onClick: onClick }, column.getHeaderProps(column.getSortByToggleProps()).key))) }, headerGroupKey));
        }) }));
}
const HeaderCell = (props) => {
    const { column } = props;
    const { key: headerKey, style: headerStyle, onClick, ...restHeaderProps } = column.getHeaderProps(column.getSortByToggleProps());
    function clickHandler(e) {
        if (onClick) {
            onClick(e);
            props.onClick(e);
        }
    }
    return (_jsxs("th", { ...restHeaderProps, style: { ...headerStyle, ...column.style, height: '1px' }, onClick: clickHandler, children: [_jsx("span", { style: sortIconStyle, children: column.isSorted ? (column.isSortedDesc ? (_jsx(FaSortAmountDown, {})) : (_jsx(FaSortAmountUp, {}))) : ('') }), column?.render('Header')] }, headerKey));
};
export default ReactTableHeader;
